import * as parent from '../variables';

export const colors = {
  ...parent.colors,
  PRIMARY_MAIN: '#f0f2f2',
  SELECTED_MENU_BG: '#101820',
  PRIMARY_CONTRAST: '#abb2c0ff',
  HEADER_BG: '#101820',
  HEADER_COUNT_TEXT: '#fff',
  NEW_THEME: true,
  PRIMARY_BORDER: '#adaeb0',
  GREY: '#999',
  DAILY_LOG_GRAPH_BORDER: '#919191',
  NORMAL_LINK: '#455560',
  MODAL_TEXT: '#797979',
  MODAL_HEADING: '#575757',
  MODAL_BACKGROUND: '#f0f2f2',
  LIST_TEXT: '#5e5f67',
  HEADER_LIST_TEXT: '#8a8a8a',
  LIGHT_BORDER: '#000000',
  SECONDARY_MAIN: '#ea2d2e',
  SECONDARY_CONTRAST: '#5e5f67',
  WHITE: '#fff',
  INPUT_BACKGROUND: '#ffffff',
  RED: '#ff0000',
  BLACK: '#000',
  BACKGROUND: '#fff',
  BLACK_THREE: '#373737',
  RED_TWO: '#d34343',
  GREEN: '#32cd32',
  GREEN_TWO: '#97AE46',
  GREY_ELEVEN: '#777070',
  GREY_TWELVE: '#c3c3c3',
  BLACK_FOUR: '#333333',
  GRAPH_BLACK: '#212121',
  CHART_BLUE: '#00e2ff',
  WARNING: '#ffff00',
  GREY_DATA: '#696969',
  SELECTED_TAB_COLOR: '#ea2d2e',
  LINK_COLOR: '#ea2d2e',
  HEADER_COLOR: '#fff',
  DOCUMENT_LINE: '#2C3249',
  DIABLED_COLOR: '#889ccc',
  RADIO_BACKGROUND: '#f0f2f2',
  FORM_COLOR: '#191e22',
  SUGGESTED_COLOR: '#00b7a0',
  BODY_BACKGROUND: '#f0f2f2',
  CHECKBOX_TICK: '#ea2d2e',
  PAGINATION_BACKGROUND: '#fff',
  PAGINATION_ALTERNATE_BACKGROUND: '#f8f8f8',
  PAGINATION_COLOR: '#fff',
  SELECTED_AREA: 'rgba(32, 177, 232, 0.6)',
  MAP: {
    LIGHT_BLACK: '#353740',
    LIGHTER_BLACK: '#353740',
    BLACK: '#353740',
    GREY: '#d1d1d1',
    LIGHT_GREY: '#d1d1d1',
    LIGHTER_GREY: '#d1d1d1',
    WATER: '#5e5f67',
    ROAD: '#37425C'
  },
  LOGIN_BUTTON: '#ea2d2e',
  TAB_LABEL: '#5e5f67',
  BACKGROUND_MENU: '#5e5f67',
  TITLE_COLOR: '#191e22',
  INPUT_COLOR: '#000',
  INPUT_BORDER: '#ccc',
  INPUT_FOCUS: '#ea2d2e',
  TABLE_ROW_COLOR: '#39434c',
  SORT_ICON: '#ea2d2e',
  LOGOUT_BUTTON: '#17181e',
  PAGINATION_HEADER: '#5e5f67',
  HEADER_TEXT: '#39434c',
  PAGINATION_BORDER: '#f0f2f2',
  RESET_BUTTON: '#2c2e33',
  ACTION_BORDER: '#5e5f67',
  PRIMARY_BUTTON_TEXT: '#fff',
  FORM_INPUT_BG: '#f0f2f2',
  MULTISELECT_BACKGROUND: '#5e5f67',
  MULTISELECT_LABEL: '#f0f2f2',
  FORM_BACKGROUND: '#fff',
  RESET_BACKGROUND: '#2c2e33',
  RESET_COLOR: '#ffffff',
  CHECKBOX_BORDER: '#d1d3d6',
  SELECT_ACTIONS: '#444',
  SECONDARY_BORDER: '#d0d4d7',
  TAB_HIGHLIGHT: '#000',
  TAB_BOTTOM_BORDER: '#ea2d2e',
  TAB_HIGHLIGHT_BACKGROUND: '#fff',
  ACCORDION_BACKGROUND: '#fff',
  USER_LOGO_BACKGROUND: '#454c60',
  USER_LOGO_COLOR: '#ea2d2e',
  POLICIES_BACKGROUND: '#fff',
  MENU_TITLE: '#fff',
  LOGIN_HEAD_TEXT: '#000',
  SELECTED_MENU_TITLE: '#fff',
  MENU_BORDER_COLOR: '#ea2d2e',
  MENU_BACKGROUND: '#636569',
  LOGIN_BACKGROUND: '#fff',
  RANGE_PICKER: {
    CELL_BG: '#dfdfdf',
    CELL_HOVER_BG: '#bbbbbb'
  }

};
export default colors;
export const fonts = ['NotoSans-Regular', 'sans-serif'].join(',');
